export const OMBELINE_MEETING_URL =
  "https://meetings.hubspot.com/ombeline-d-arras?uuid=71dd737e-d044-48cc-b6c1-8e138a349583";

export const OMBELINE_MEETING_EMBED_URL = `${OMBELINE_MEETING_URL}&embed=true`;
